export type { LanguageSwitcherProps, LanguageSwitcherOption } from './language-switcher';
export { LanguageSwitcher } from './language-switcher';
